import { FC, Fragment } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';
import { Link } from '@hh.ru/redux-spa-middleware';

import Button, { ButtonKind } from 'bloko/blocks/button';
import { H2Section } from 'bloko/blocks/header';

interface ReasonProps {
    title: string;
    text: string;
    action?: string;
    anchor?: string;
}

const Reason: FC<ReasonProps> = ({ title, text, action, anchor }) => (
    <Fragment>
        <H2Section lite>{title}</H2Section>
        <VSpacing default={8} />
        <p>{text}</p>
        {action && anchor && (
            <>
                <VSpacing default={16} />
                <Button Element={Link} to={action} kind={ButtonKind.Success}>
                    {anchor}
                </Button>
            </>
        )}
    </Fragment>
);

export default Reason;
